import { useAdditionalIncomeFieldBindings } from "@Client/@Composables/application-standalone/pages/additional-income/useAdditionalIncomeFieldBindings";
import { useAdditionalIncomeFieldVisibility } from "@Client/@Composables/application-standalone/pages/additional-income/useAdditionalIncomeFieldVisibility";
export const additionalIncomeBindingsAndVisibilities = (applicantIndex, incomeIndex) => {
  const {
    additionalIncomeAmount,
    additionalIncomeDescription,
    additionalIncomeIncomePeriod,
    additionalIncomeType
  } = useAdditionalIncomeFieldBindings({
    applicantIndex,
    additionalIncomeIndex: incomeIndex
  });
  const {
    additionalIncomeAmountVisible,
    additionalIncomeDescriptionVisible,
    additionalIncomeTypeVisible,
    additionalIncomeIncomePeriodVisible
  } = useAdditionalIncomeFieldVisibility({
    applicantIndex
  });
  return {
    bindings: {
      additionalIncomeAmount,
      additionalIncomeDescription,
      additionalIncomeIncomePeriod,
      additionalIncomeType
    },
    visibilities: {
      additionalIncomeAmountVisible,
      additionalIncomeDescriptionVisible,
      additionalIncomeTypeVisible,
      additionalIncomeIncomePeriodVisible
    }
  };
};